import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import cookies from "js-cookie";
import EditDetailsofMember from "../../Models/EditMeberModel/EditMember";
import AddMember from "../../Models/EditMeberModel/AddMember";
import { GetMembers, DeletetMembers } from "../../apis/api/MemberApi";
import BusinessCardModel from "../../Models/BuisnessCardsModel/BuisnessCardsModel";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import "./Member.css";

const MemberCard = () => {
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [AddMemberModal, setAddMemberModal] = useState(false);
  const [memberData, setmemberData] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [showBuisnessModal, setShowBuisnessModal] = useState(false);
  const [businessCardData, setShowBuisnesscard] = useState();
  const UserID = cookies.get("userID");
  const companyID = cookies.get("company_id");
  const access = JSON.parse(cookies.get("access") || "{}");
  const location = useLocation();
  const navigate = useNavigate();
  const { company_id, userId } = location.state || {};
  const effectiveCompanyId = company_id || companyID;
  const effectiveUserId = userId || UserID;

  const dispatch = useDispatch();
  const { contactdata } = useSelector((state) => state.MemberSlice);

  const Openmodel = (data) => {
    setmemberData(data);
    setShowMemberModal(true);
  };

  useEffect(() => {
    (async () => {
      if (!effectiveCompanyId || !effectiveUserId) return;
      await dispatch(GetMembers({ company_id: effectiveCompanyId, userId: effectiveUserId }));
    })();
  }, [dispatch, effectiveCompanyId, effectiveUserId]);

  const handleDeleteClick = (memberId) => {
    setSelectedMemberId(memberId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedMemberId) {
      await dispatch(DeletetMembers({ selectedMemberId }));
      setShowDeleteModal(false);
      setSelectedMemberId(null);
      if (effectiveCompanyId && effectiveUserId) {
        await dispatch(GetMembers({ company_id: effectiveCompanyId, userId: effectiveUserId }));
      }
    }
  };

  function filterMemeberDataforCard(id) {
    const filterddata = contactdata.data.filter((member) => {
      return member.id == id;
    });
    setShowBuisnesscard(filterddata);
    setShowBuisnessModal(true);
  }
  return (
    <>
      <AddMember
        show={AddMemberModal}
        onHide={() => setAddMemberModal(false)}
        Company_id={company_id}
      />
      <BusinessCardModel
        show={showBuisnessModal}
        handleClose={() => setShowBuisnessModal(false)}
        data={businessCardData}
      />
      <EditDetailsofMember
        show={showMemberModal}
        onHide={() => setShowMemberModal(false)}
        data={memberData}
        company_id={company_id}
        userId={UserID}
      />

      <ConfirmModal
        isOpen={showDeleteModal}
        message="Are you sure you want to delete this member?"
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
      />

      <motion.div
        className="mb-wrap"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.32, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="mb-hero">
          <div>
            <div className="mb-kicker">
              <i className="bx bx-group"></i>
              Members
            </div>
            <h1 className="mb-title">Team Members</h1>
            <p className="mb-sub">
              Manage contacts for your company. View business cards, edit details,
              or add new members.
            </p>
          </div>

          <div className="mb-hero-actions">
            <span className="mb-pill">
              {(Array.isArray(contactdata?.data) ? contactdata.data.length : 0)} members
            </span>
            {(access.extra_contact && access.extra_contact === "1") &&
              (UserID === effectiveUserId && companyID === effectiveCompanyId) && (
                <button
                  className="mb-primary"
                  onClick={() => setAddMemberModal(true)}
                  type="button"
                >
                  <i className="bx bx-plus"></i> Add Member
                </button>
              )}
          </div>
        </div>

        {Array.isArray(contactdata?.data) && contactdata.data.length > 0 ? (
          <div className="mb-grid">
            {contactdata.data.map((member, index) => {
              const nameParts = [
                member.salutation,
                member.first_name,
                member.middle_name,
                member.last_name,
              ].filter(
                (part) => part && part !== "null" && part !== "undefined"
              );

              const fullName = nameParts.join(" ");
              return (
                <motion.article
                  key={member.id ?? index}
                  className="mb-card"
                  whileHover={{ y: -4 }}
                  transition={{ duration: 0.18 }}
                >
                  <div className="mb-card-top">
                    <div className="mb-avatar">
                      <img
                        src={
                          member.member_logo ||
                          `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                        }
                        alt={fullName || "member"}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src =
                            `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`;
                        }}
                      />
                    </div>

                    {(UserID === effectiveUserId && companyID === effectiveCompanyId) && (
                      <div className="mb-actions">
                        <button
                          className="mb-icon"
                          onClick={() => Openmodel(member)}
                          type="button"
                          aria-label="Edit"
                        >
                          <i className="bx bx-edit"></i>
                        </button>
                        <button
                          className="mb-icon danger"
                          onClick={() => handleDeleteClick(member.id)}
                          type="button"
                          aria-label="Delete"
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="mb-card-body">
                    <div className="mb-name">{fullName || "—"}</div>
                    <div className="mb-meta">
                      {member.job_title ? <span>{member.job_title}</span> : <span>Member</span>}
                      {member.department ? <span className="dot">•</span> : null}
                      {member.department ? <span>{member.department}</span> : null}
                    </div>
                    {(() => {
                      const branchLoc = [member.branch_city, member.branch_country].filter(Boolean).join(", ");
                      return (branchLoc || member.branch_type || member.branch_id) ? (
                        <div className={`mb-branch ${member.branch_main_branch === 1 ? 'mb-branch--hq' : ''}`}>
                          <i className="bx bx-buildings"></i>
                          <span>
                            {branchLoc
                              ? `${branchLoc} ${member.branch_main_branch === 1 ? '(HQ)' : '(Branch)'}`
                              : (member.branch_type || (member.branch_main_branch === 1 ? 'Head Office' : 'Branch Office'))}
                          </span>
                        </div>
                      ) : null;
                    })()}
                    {member.email && (
                      <div className="mb-email">
                        <i className="bx bx-envelope"></i>
                        <span>{member.email}</span>
                      </div>
                    )}
                  </div>

                  <div className="mb-card-foot">
                    <button
                      className="mb-btn"
                      onClick={() => filterMemeberDataforCard(member.id)}
                      type="button"
                    >
                      <i className="bx bx-show"></i> Business Card
                    </button>
                    <div className="mb-social">
                      {member?.contact && (
                        <a
                          href={`https://wa.me/${String(member.country_code).replace(/\D/g, "")}${String(member.contact).replace(/\D/g, "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mb-soc wa"
                          aria-label="WhatsApp"
                        >
                          <i className="bx bxl-whatsapp"></i>
                        </a>
                      )}
                      {member?.email && (
                        <a
                          href={`mailto:${member.email}`}
                          className="mb-soc em"
                          aria-label="Email"
                        >
                          <i className="bx bx-envelope"></i>
                        </a>
                      )}
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </div>
        ) : (
          <div className="mb-empty">
            <i className="bx bx-user-x"></i>
            <h3>No members found</h3>
            <p>Add your first member to start building your contact list.</p>
            {(access.extra_contact && access.extra_contact === "1") &&
              (UserID === effectiveUserId && companyID === effectiveCompanyId) && (
                <button className="mb-primary" onClick={() => setAddMemberModal(true)} type="button">
                  <i className="bx bx-plus"></i> Add Member
                </button>
              )}
          </div>
        )}
      </motion.div>
    </>
  );
};

export default MemberCard;
